import { ChangeDetectorRef, Component, ElementRef, SimpleChanges, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { TextFieldModule } from '@angular/cdk/text-field';
import { FormsModule } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserService } from '../services/user.service';
import { AjaxService } from '../services/ajax.service';
import { Subscription } from 'rxjs';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export interface AssessmentPlan {
  name: string;
  type: string;
  assessed: string;
  date: string;
  target: string;
  responsibility: string;
}



@Component({
  selector: 'app-data-and-assement-plan',
  standalone: true,
  imports: [CommonModule, FormsModule, MatTableModule, TextFieldModule],
  templateUrl: './data-and-assement-plan.component.html',
  styleUrl: './data-and-assement-plan.component.scss'
})
export class DataAndAssementPlanComponent {

  showExport = false;
  displayedColumns: string[] = ['name', 'type', 'assessed', 'date', 'target', 'responsibility'];
  dataSource = new MatTableDataSource<AssessmentPlan>();
  edit = false
  schoolId : number = 0;
  userSubscription : Subscription[] = []

  @ViewChild('contentToExport') contentToExport: any;
  constructor (private changeDetector: ChangeDetectorRef, public _snackbar : MatSnackBar, private _userService : UserService, private _ajaxService : AjaxService) {

  }

  ngOnInit() {
    this.userSubscription.push(this._userService.getSchoolId().subscribe(value => {
      if (value) this.schoolId = value
      this.getAssessmentData();
    }))
  }

  toggleExport () {
    this.showExport = !this.showExport
  }

  toggleEdit() {
    this.edit = !this.edit;
    const data = [...this.dataSource.data];
    this.dataSource = new MatTableDataSource<AssessmentPlan>([]);
    this.changeDetector.detectChanges();
    this.dataSource = new MatTableDataSource<AssessmentPlan>(data);
  }

  addData() {
    this.edit = true;
    this.addRow();
  }

  addRow() {
    const row = [{name: '', type: '', assessed: '', date: '', target : '' , responsibility : ''}]
    this.dataSource.data.push(...row)
    const data = [...this.dataSource.data];
    this.dataSource = new MatTableDataSource<AssessmentPlan>([]);
    this.changeDetector.detectChanges();
    this.dataSource = new MatTableDataSource<AssessmentPlan>(data);
  }

  save() {
    if (this.dataSource.data.length > 0) {
      const isEmpty = this.dataSource.data.map((obj: any) => {
        const {name, type, date, target, responsibility} = obj;
        return [name, type, date, target, responsibility].some((field) => !field || field?.trim() === "")
      });
  
      if (isEmpty.some(field => field === true)) {
        this._snackbar.open("All Fields Are Required", "OK", { duration: 3000, panelClass: "warning-success" });
        return
      }

      const request = {
        schoolId : this.schoolId,
        data : this.dataSource.data
      }

      this._ajaxService.post('assessment/saveAssessment', request).then((response: any) => {
        if (response.statusCode == 200) {
          this.edit = false;
          this.getAssessmentData();
          this._snackbar.open("Annual Data Target Updated Successfully", "OK", { duration: 3000, panelClass: "warning-success" });
        }
      })
      .catch(error => {
        let displayError = error.error.message
        if (error.error.message === undefined) displayError = `Technical Issue Please Try Again!`
        this._snackbar.open(`${displayError}`, "OK", { duration: 3000, panelClass: "error-dialog" })
      })
      
    }
  }

  getAssessmentData(){
    this._ajaxService.get(`assessment/getAssessment/${this.schoolId}`).then((response: any) => {
      if (response.statusCode == 200) {
        this.dataSource = new MatTableDataSource<AssessmentPlan>(response.data);
      }
    })
  }

  exportToPdf() {
    if (this.edit) {
      this._snackbar.open(`Export function is unavailable while in edit mode. Please save all your changes before attempting to export.`, "OK", { duration: 6000, panelClass: "error-dialog", });
      return
    }
    const content = this.contentToExport.nativeElement;
    html2canvas(content).then(canvas => {
      const imgWidth = 210;
      const pageHeight = 300;
      const imgHeight = canvas.height * imgWidth / canvas.width;
      let heightLeft = imgHeight + 1;
      const FILEURI = canvas.toDataURL('image/png');
      let PDF = new jsPDF('p', 'mm', 'a4');
      let position = 0;
    
      PDF.addImage(FILEURI, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;
    
      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        PDF.addPage();
        PDF.addImage(FILEURI, 'PNG', 0, position + pageHeight, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }
    
      PDF.save('DataAssessmentPlan.pdf');
    });
  }
}
